// import { loginRequest, loginSuccess, loginFailure } from '../action/loginAction';
import {
  profileFailuer,
  profileRequest,
  profileSuccess,
} from "../action/profileAction";
import config from "../../../config";
import { useDispatch, useSelector } from "react-redux";
import axiosInstance from "../../../util/axiosInstance";

import { getToken } from "../../../util/Cookies";
import { decodeToken } from "react-jwt";

export const getProfile = async () => {
  //dispatch(profileRequest());
  // const token=sessionStorage.getItem('token');

  const token = getToken();
  const decodedToken = decodeToken(token);
  const userType = decodedToken?.userType || null;

  try {
    const response = await axiosInstance.get(
      `/${userType === "provider" ? "provider" : "user"}/profile`,
      {
        method: "GET",
        headers: {
          Authorization: `${token}`,
        },
      }
    );    
    const data = response.data;
    if (response.status === 200) {
      return data.data;
    } else {
      throw new Error(data.message || "Login failed");
    }
  } catch (error) {
    console.error("There was a problem with the fetch operation:", error);
  }
};


export const uploadImage = async (file) => {
  const token = getToken();
  const formData = new FormData();
  formData.append("file", file);

  try {
    const response = await axiosInstance.post("/gallery/upload", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `${token}`,
      },
    });
    const data = response.data;
    console.log(data);
    if (response.status === 200 || response.status === 201) {
      return data.file.id; // return only file id
    } else {
      throw new Error(data.message || "Unable to upload image");
    }
  } catch (error) {
    console.error("Error uploading image:", error);
    throw error;
  }
};


export const getServiceProviderProfile = async () => {
  const token = getToken();

  try {
    const response = await axiosInstance.get("/provider/profile", {
      method: "GET",
      headers: {
      
        Authorization: `${token}`,
      },
    });    
    const data = response.data;    
    if (response.status === 200) {
      return data.data;
    } else {
      throw new Error(data.message || "Unable to get the provider details");
    }
  } catch (error) {
    console.error("There was a problem with the fetch operation:", error);
  }
};


export const getServiceProviderOrders = async () => {
  const token = getToken();

  try {
    const response = await axiosInstance.get("/provider-orders/orders", {
      method: "GET",
      headers: {
      
        Authorization: `${token}`,
      },
    });    
    const data = response.data;    
    if (response.status === 200) {
      return data.result;
    } else {
      throw new Error(data.message || "Unable to get the provider orders");
    }
  } catch (error) {
    console.error("There was a problem with the fetch operation:", error);
  }
};

export const getProviderVenueOrders = async () => {
  const response = await axiosInstance.get('/v1/provider/venue-orders');
  return response.data?.data || [];
};


export const serviceProviderAcceptOrRejectOrder = async (orderId, isAccepted) => {
  try {
  const token = getToken();
   const response = await axiosInstance.put(
          `provider-orders/orders?cartItemId=${orderId}`,
            { isAccepted: isAccepted },
          {
            method: "PUT",
            headers: {
              Authorization: `${token}`,
            },
          }
        );

    if (response.status === 200) {
      const body = response.data;

      if (body.success === false) {
        throw new Error(
          `Error in ${isAccepted ? "Accepting" : "Rejecting"} the order`
        );
      }

      return null; // success
    } else {
      return "Invalid response from server";
    }
  } catch (e) {
    return `Error: ${e.message}`;
  }
};



export const getServiceProviderBusinessDetails = async () => {
  // const token = getToken();
  const token = getToken();

  try {
    const response = await axiosInstance.get("/provider/profile/business", {
      headers: {
        Authorization: `${token}`,
      },
    });

    const data = response.data;
    console.log("busineess",data);
    if (response.status === 200) {
      return data.data;
    } else {
      throw new Error(data.message || "Unable to get business details");
    }
  } catch (error) {
    console.error("Error fetching business info:", error);
    throw error;
  }
};
export const getServiceProviderProfileView = async (id) => {
  
  try {
    const response = await axiosInstance.get("/provider/profileview", {
      method: "GET",
      headers: {
        "x-provider-id": id,
       
      },
    });
    const data = response.data;
    console.log("Response in",data)
    if (response.status === 200) {
      return data.data;
    } else {
      throw new Error(data.message || "Unable to get the provider details");
    }
  } catch (error) {
    console.error("There was a problem with the fetch operation:", error);
  }
};

export const getServiceProviderBusinessDetailsView = async (id) => {
 
  try {
    const response = await axiosInstance.get("/provider/profile/businessview", {
      headers: {
        "x-provider-id": id,
      },
    });

    const data = response.data;
    if (response.status === 200) {
      return data.data;
    } else {
      throw new Error(data.message || "Unable to get business details");
    }
  } catch (error) {
    console.error("Error fetching business info:", error);
    throw error;
  }
};


export const updateServiceProviderProfile = async (id, payload,) => {
  const token = getToken();
  try {
    const response = await axiosInstance.put(`/provider/profile`, payload, {
      headers: {
        Authorization: `${token}`,
      },
    });
    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error(response.data.message || "Failed to update profile details");
    }
  } catch (error) {
    console.error("Error updating profile:", error);
    throw error;
  }
};

export const updateServiceProviderBusiness = async (id, payload) => {
  const token = getToken();
  try {
    const response = await axiosInstance.post(`/provider/profile/business`,payload, {
      headers: {
        Authorization: `${token}`,
      },
    });
    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error(response.data.message || "Failed to update business details");
    }
  } catch (error) {
    console.error("Error updating business:", error);
    throw error;
  }
};

